import dayjs from 'dayjs'
import { redirect } from 'react-router-dom'
import useAppStore from '$appStore'
import { FeatureFlag, PREFER_NEW_PURCHASE_ORDER_WORKFLOW_KEY } from '$constants'

/**
 * Checks if user should be redirected to old purchase order workflow.
 * Returns redirect Response if should redirect, null otherwise.
 */
export const getOldWorkflowRedirect = (
  fallbackPath: string
): ReturnType<typeof redirect> | null => {
  const featureFlags = useAppStore.getState().featureFlags
  if (featureFlags.has(FeatureFlag.PurchaseOrders)) return null

  const prefersNewWorkflow = window.localStorage.getItem(
    PREFER_NEW_PURCHASE_ORDER_WORKFLOW_KEY
  )
  if (!prefersNewWorkflow) return redirect(fallbackPath)

  return null
}

/**
 * Appends order history filters as query params to invoice URLs.
 * This allows users to return to the same filtered view after editing an invoice.
 * @param basePath - The base path to append query params to
 * @param filters - The order history filters to append
 * @returns The path with query params appended
 */
export const appendOrderHistoryFilters = (
  basePath: string,
  filters: {
    from?: dayjs.Dayjs
    to?: dayjs.Dayjs
    referenceNumber: string
    supplierId: string
  } | null
): string => {
  if (!filters) return basePath

  const searchParams = new URLSearchParams()
  if (filters.from) {
    searchParams.set('fromDate', filters.from.toISOString())
  }
  if (filters.to) {
    searchParams.set('toDate', filters.to.toISOString())
  }
  if (filters.referenceNumber) {
    searchParams.set('referenceNumber', filters.referenceNumber)
  }
  if (filters.supplierId) {
    searchParams.set('supplier', filters.supplierId)
  }

  const queryString = searchParams.toString()
  return queryString ? `${basePath}?${queryString}` : basePath
}
